import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tab',
  standalone: false,
  template: `
    <div *ngIf="active" class="tab-panel">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`:host { display: block; }`]
})
export class TabComponent {
  @Input() header = '';
  active = false;
}
